import React from 'react'

export const SetupContext = React.createContext();